export const buildRedirectLink = (
  link: string,
  tmp_token: string,
  lang: string,
  olybetToken?: string,
) => {
  const url = new URL(link);

  url.searchParams.set('token', tmp_token);
  url.searchParams.set('lang', lang);
  if (olybetToken) {
    url.searchParams.set('olybetToken', olybetToken);
  }

  return url.toString();
};
